import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FormControlLabel, Grid, Radio, RadioGroup} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Background from "./assets/bundle-banner.png"
import {compose} from "redux";
import {connect} from "react-redux";
import {setCustomerData, setOffersData, updateStep} from "../../../../core/store/actions/index";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";

const styles = {
    root: {
        flexGrow: 1,
    },
    mainContainer:{
        paddingTop:"80px"
    },
    textDiv:{
        textAlign:"right"
    },
    outerCard:{
        width:"360px"
    },
    innerCard:{
        marginTop:"20px",
        borderRadius:"10px"
    },
    head:{
        padding:"20px"
    },
    radioBtnBox:{
        marginTop: "15px",

    },
    radioGroup:{
        display:"flex",
        flexDirection:"row",
        justifyContent:"center"
    },
    cardContent:{
        padding:"20px"
    },
    radioGroupColumn:{
        display:"flex",
        flexDirection:"column",
        justifyContent:"center",
        paddingLeft:"24%"
    },
    nextBtn:{
        marginTop:"20px",
        borderRadius: "50px"
    }
};


class BasicDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            financial_year:"2020-2021",
            current_age:"Below 60 years"
        };
    }

    componentDidMount() {

    }

    handleFinancialYearChange = (e)=>{
        this.setState({financial_year : e.target.value})
    }
    onClickNext = ()=>{
        this.props.updateStep(this.props.step+1)
    }

    render() {
        const {classes} = this.props;
        const {
            email, contact_number, coupon, city, couponButtonDisable, sending,
            email_error, contact_number_error, addOnArray, errors, loading, success_msg,financial_year
        } = this.state
        return (
            <Grid container justify={"center"} className={classes.mainContainer}>
                        <div className={classes.outerCard}>
                            <Typography variant={'h4'} component={'h4'}>
                               Basic Detalis
                            </Typography>
                            <Paper elevation={3} className={classes.innerCard}>
                                <div className={classes.head}>
                                    <Typography variant={'body1'} >
                                        Financial Year
                                    </Typography>
                                    <div className={classes.radioBtnBox}>
                                        <RadioGroup value={financial_year} onChange={this.handleFinancialYearChange} className={classes.radioGroup}>
                                            <FormControlLabel value={"2019-2020"} control={<Radio color={"primary"}/>} label={"2019-2020"}/>
                                            <FormControlLabel value={"2020-2021"} control={<Radio color={"primary"}/>} label={"2020-2021"}/>
                                        </RadioGroup>
                                    </div>
                                </div>
                                <Divider/>
                                <div className={classes.cardContent}>
                                    <Typography variant={'body1'} >
                                        Your Current Age
                                    </Typography>
                                    <div className={classes.radioBtnBox}>
                                        <RadioGroup value={financial_year} onChange={this.handleFinancialYearChange} className={classes.radioGroupColumn}>
                                            <FormControlLabel value={"Below 60 years"} control={<Radio color={"primary"}/>} label={"Below 60 years"}/>
                                            <FormControlLabel value={"60 to 80 years"} control={<Radio color={"primary"}/>} label={"60 to 80 years"}/>
                                            <FormControlLabel value={"80 years or above "} control={<Radio color={"primary"}/>} label={"80 years or above"}/>
                                        </RadioGroup>
                                    </div>
                                    <Button variant="contained" color="primary" className={classes.nextBtn}
                                            onClick={this.onClickNext}>
                                        Next
                                    </Button>
                                </div>
                            </Paper>
                        </div>
            </Grid>)
    }
}

const mapStateToProps = (state) => ({
    access_token: state.globals.access_token,
    offers_data: state.globals.offers_data,
    step: state.globals.step,
    customer_email: state.globals.customer_email,
    customer_contact_number: state.globals.customer_contact_number
})

const mapDispatchToProps = {
    setOffersData, updateStep, setCustomerData
}


export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(BasicDetails);
